export enum ApprovalStatus {
  Waiting = 0,
  Approved = 1,
  Rejected = 2,
}
